export default {
  /** 共通 */
  'pages.common.required': '入力してください',

  /** ログイン */
  'pages.layouts.userLayout.title': ' ',
  'pages.login.accountLogin.errorMessage': 'ユーザー名/パスワードが正しくありません',
  'pages.login.failure': 'ログイン失敗、再度ログインを試してください',
  'pages.login.success': 'ログイン成功',
  'pages.login.username.placeholder': 'ユーザーID',
  'pages.login.username.required': 'ユーザーIDを入力してください',
  'pages.login.password.placeholder': 'パスワード',
  'pages.login.password.required': 'パスワードを入力してください',
  'pages.login.rememberMe': 'ログイン状態を一定期間保持',
  'pages.login.submit': 'ログイン',

  /** ユーザー一覧 */
  'pages.userlist.item.customername': '契約者名',
  'pages.userlist.item.userid': 'ID',
  'pages.userlist.item.name': '名前',
  'pages.userlist.item.role': '権限',
  'pages.userlist.item.available': '有効／無効',
  'pages.userlist.item.operation': '操作',
  'pages.userlist.button.note': 'メモ',
  'pages.userlist.availabilty.valid': '有効',
  'pages.userlist.availabilty.invalid': '無効',
  'pages.userlist.button.add': '新規登録',
  'pages.userlist.button.update': '編集',
  'pages.userlist.button.delete': '削除',
  'pages.userlist.delete.check': '削除しますか？',
  'pages.userlist.delete.exec': 'ユーザーID:{userid}を削除しました',
  'pages.userlist.delete.failed': '削除に失敗しました',

  /** ユーザー登録／編集 */
  'pages.user.item.customername': '契約者名',
  'pages.user.item.userid': 'ID',
  'pages.user.item.name': '名前',
  'pages.user.item.password': 'パスワード',
  'pages.user.item.confirmpassword': 'パスワード（確認）',
  'pages.user.item.role': '権限',
  'pages.user.item.role.admin': '管理者',
  'pages.user.item.role.infouser': 'お知らせ登録者',
  'pages.user.item.invalidflag': '無効',
  'pages.user.button.save': '保存',
  'pages.user.button.back': '戻る',
  'pages.user.customername.required': '契約者名を入力してください',
  'pages.user.userid.required': 'IDを入力してください',
  'pages.user.name.required': '名前を入力してください',
  'pages.user.role.required': '権限を選択してください',
  'pages.user.password.required': 'パスワードを入力してください',
  'pages.user.confirmpassword.required': 'パスワード（確認）を入力してください',
  'pages.user.password.pattern': '8文字以上で、数字・小文字・大文字をそれぞれ1文字以上含めてください',
  'pages.user.password.placeholder': '変更する場合のみ入力してください',
  'pages.user.password.mismatch': 'パスワードが一致しません',
  'pages.user.userinfo.create': 'ユーザーを作成しました',
  'pages.user.userinfo.update': 'ユーザー情報を更新しました',
  'pages.user.userinfo.save.error': '保存に失敗しました。\n{messages}',

  /** 契約者一覧 */
  'pages.customerlist.item.name': '契約者名',
  'pages.customerlist.item.schema': 'テナントスキーマ',
  'pages.customerlist.item.note': 'メモ',
  'pages.customerlist.item.operation': '操作',
  'pages.customerlist.button.add': '新規登録',
  'pages.customerlist.button.update': '編集',
  'pages.customerlist.button.delete': '削除',
  'pages.customerlist.delete.check': '削除しますか？',
  'pages.customerlist.delete.exec': 'ユーザーID:{userid}を削除しました',
  'pages.customerlist.delete.failed': '削除に失敗しました',

  /** 契約者登録／編集 */
  'pages.customer.item.customername': '契約者名',
  'pages.customer.item.schemaname': 'テナントスキーマ名',
  'pages.customer.item.note': 'メモ',
  'pages.customer.button.save': '保存',
  'pages.customer.button.back': '戻る',
  'pages.customer.customername.required': '契約者名を入力してください',
  'pages.customer.schemaname.required': 'スキーマ名を入力してください',
  'pages.customer.schemaname.length': 'スキーマ名は128文字以内で入力してください',
  'pages.customer.schemaname.validationErr': 'スキーマ名はtenant_半角数字3桁(001～999)の形式で入力してください',
  'pages.customer.customerinfo.create': '契約者情報を作成しました',
  'pages.customer.customerinfo.update': '契約者情報を更新しました',

  /** 契約者メモ編集 */
  'pages.customer.note.item.customername': '契約者名',
  'pages.customer.note.item.schemaname': 'テナントスキーマ名',
  'pages.customer.note.item.content': 'メモ',
  'pages.customer.note.button.save': '保存',
  'pages.customer.note.button.back': '戻る',
  'pages.customer.note.customername.required': '契約者名は必須です',
  'pages.customer.note.content.length': 'メモは150文字以内で入力してください',
  'pages.customer.note.content.create': '契約者情報を作成しました',
  'pages.customer.note.content.update': '契約者情報を更新しました',
  'pages.customer.note.item.historylist': 'メモ履歴一覧',
  'pages.customer.note.item.historydate': '登録日',
  'pages.customer.note.item.historycontent': 'メモ内容',

  /** 以降：okayama → customerTop へ置換済 */
  /** 事業者一覧 */
  'pages.customerTop.agencylist.item.name': '事業者名',
  'pages.customerTop.agencylist.item.currentrevisiondata': 'ダイヤ改正日',
  'pages.customerTop.agencylist.item.nextrevisiondata': '次回ダイヤ改正日',
  'pages.customerTop.agencylist.item.contractstart': 'RT連携開始日',
  'pages.customerTop.agencylist.item.contractend': 'RT連携終了日',
  'pages.customerTop.agencylist.item.status': '連携状態',
  'pages.customerTop.agencylist.item.status.normal': '正常',
  'pages.customerTop.agencylist.item.status.abnormal': '異常',
  'pages.customerTop.agencylist.item.gtfsrtcycle': 'RT連携周期（秒）',
  'pages.customerTop.agencylist.item.gtfsrtcycle.15s': '15秒',
  'pages.customerTop.agencylist.item.gtfsrtcycle.20s': '20秒',
  'pages.customerTop.agencylist.item.gtfsrtcycle.30s': '30秒',
  'pages.customerTop.agencylist.item.xxx': 'JP最終連携日時',
  'pages.customerTop.agencylist.item.testmode': 'テストモード',
  'pages.customerTop.agencylist.item.testmode.valid': 'ON',
  'pages.customerTop.agencylist.item.testmode.invalid': 'OFF',
  'pages.customerTop.agencylist.item.operation': '操作',
  'pages.customerTop.agencylist.button.add': '新規登録',
  'pages.customerTop.agencylist.button.update': '編集',
  'pages.customerTop.agencylist.button.jpaccess': 'JP即時取得',
  'pages.customerTop.agencylist.jpaccess.check': 'JP即時取得しますか？',
  'pages.customerTop.agencylist.button.jsonrebuild': 'ダイヤ再構築',
  'pages.customerTop.agencylist.jsonrebuild.check': '定刻ダイヤを再構築しますか？',
  'pages.customerTop.agencylist.button.delete': '削除',
  'pages.customerTop.agencylist.delete.check': '削除しますか？',
  'pages.customerTop.agencylist.delete.exec': '事業者ID:{agencyid}を削除しました',
  'pages.customerTop.agencylist.delete.failed': '削除に失敗しました',
  /** 事業者登録／編集 */
  'pages.customerTop.agency.item.agencyname': 'バス事業者名',
  'pages.customerTop.agency.item.agencyshortname1': 'バス事業者名（略称）',
  'pages.customerTop.agency.item.agencyshortname2': 'バス事業者名（略称＋バス）',
  'pages.customerTop.agency.item.gtfsjpurlcurrent': 'GTFS-JP(現)URL',
  'pages.customerTop.agency.item.gtfsjpurlnext': 'GTFS-JP(新)URL',
  'pages.customerTop.agency.item.gtfsjpcycle': 'GTFS-JP周期(時間)',
  'pages.customerTop.agency.item.gtfsjpcycle.6h': '6時間',
  'pages.customerTop.agency.item.gtfsjpcycle.12h': '12時間',
  'pages.customerTop.agency.item.gtfsjpcycle.24h': '24時間',
  'pages.customerTop.agency.item.gtfsrturltripupdate': 'GTFS-RT(Trip Update)URL',
  'pages.customerTop.agency.item.gtfsrturlvehicle': 'GTFS-RT(Vehicle Position)URL',
  'pages.customerTop.agency.item.gtfsrturlalert': 'GTFS-RT(Alert)URL',
  'pages.customerTop.agency.item.gtfsrtcycle': 'GTFS-RT周期(秒)',
  'pages.customerTop.agency.item.gtfsrtcycle.15s': '15秒',
  'pages.customerTop.agency.item.gtfsrtcycle.20s': '20秒',
  'pages.customerTop.agency.item.gtfsrtcycle.30s': '30秒',
  'pages.customerTop.agency.item.contractstart': '連携開始日',
  'pages.customerTop.agency.item.contractend': '連携終了日',
  'pages.customerTop.agency.item.testmode': 'テストモード',
  'pages.customerTop.agency.item.testmodenotes': '（※事業者新規登録時、テストモードを有効にする場合、事業者一覧「JP即時取得ボタン」を押してください）',
  'pages.customerTop.agency.button.save': '保存',
  'pages.customerTop.agency.button.back': '戻る',
  'pages.customerTop.agency.agencyname.required': '事業者名を入力してください',
  'pages.customerTop.agency.gtfsjpurlcurrent.required': '有効な 現行の GTFS-JP URLを入力してください',
  'pages.customerTop.agency.gtfsjpurlnext.required': '有効な 次期の GTFS-JP URLを入力してください',
  'pages.customerTop.agency.gtfsrturlupdate.required': '有効な GTFS-RT (Trip Update) URLを入力してください',
  'pages.customerTop.agency.gtfsrturlvehicle.required': '有効な GTFS-RT (Vehicle Position) URLを入力してください',
  'pages.customerTop.agency.gtfsrturlalert.required': '有効な GTFS-RT (Alert) URLを入力してください',
  'pages.customerTop.agency.contractstart.required': '連携開始日を入力してください',
  'pages.customerTop.agency.agencyinfo.create': '事業者情報を作成しました',
  'pages.customerTop.agency.agencyinfo.update': '事業者情報を更新しました',

  /** お知らせ一覧 */
  'pages.customerTop.noticelist.item.title': 'タイトル',
  'pages.customerTop.noticelist.item.body': '内容',
  'pages.customerTop.noticelist.item.upduser': '最終更新者',
  'pages.customerTop.noticelist.item.updtim': '最終更新日時',
  'pages.customerTop.noticelist.item.releasstartdate': '配信開始',
  'pages.customerTop.noticelist.item.releasenddate': '配信終了',
  'pages.customerTop.noticelist.item.stop_groupnum': '対象標柱グループ数',
  'pages.customerTop.noticelist.item.status': '適用状態',
  'pages.customerTop.noticelist.item.status.scheduled': '配信予定',
  'pages.customerTop.noticelist.item.status.running': '配信中',
  'pages.customerTop.noticelist.item.status.finished': '配信終了',
  'pages.customerTop.noticelist.item.operation': '操作',
  'pages.customerTop.noticelist.button.add': '新規登録',
  'pages.customerTop.noticelist.button.update': '編集',

  /** お知らせ登録／編集 */
  'pages.customerTop.notice.item.noticetitle': 'タイトル',
  'pages.customerTop.notice.item.noticebody': '内容',
  'pages.customerTop.notice.item.stop_group': '標柱グループ',
  'pages.customerTop.notice.item.stop_groupno': 'No',
  'pages.customerTop.notice.item.stop_groupname': '標柱グループ名',
  'pages.customerTop.notice.item.stop_grouplist': '【標柱グループ一覧】',
  'pages.customerTop.notice.item.stop_groupcount': '【対象標柱グループ】',
  'pages.customerTop.notice.item.search': '検索',
  'pages.customerTop.notice.item.releasstart': '配信開始日',
  'pages.customerTop.notice.item.releaseend': '配信終了日',
  'pages.customerTop.notice.item.upduser': '最終更新者',
  'pages.customerTop.notice.item.updtim': '最終更新日時',
  'pages.customerTop.notice.button.clear': 'クリア',
  'pages.customerTop.notice.button.save': '保存',
  'pages.customerTop.notice.button.back': '戻る',
  'pages.customerTop.notice.noticetitle.required': 'タイトルは６４文字以内で入力してください',
  'pages.customerTop.notice.noticebody.required': '内容は５００文字以内で入力してください',
  'pages.customerTop.notice.stop_groupcount.required': '配信対象の標柱グループを選択してください',
  'pages.customerTop.notice.releasestart.required': '配信開始日を入力してください',
  'pages.customerTop.notice.releaseend.required': '配信終了日を入力してください',
  'pages.customerTop.notice.noticeinfo.create': '新規お知らせ情報を作成しました',
  'pages.customerTop.notice.noticeinfo.update': 'お知らせ情報を更新しました',
  'pages.customerTop.noticeinfo.clear.check': 'クリアしますか？',
  'pages.customerTop.noticeinfo.clear.exec': 'お知らせ内容:{body}をクリアしました',
  'pages.customerTop.noticeinfo.clear.failed': 'クリアに失敗しました',

  /** 方面一覧 */
  'pages.customerTop.route_grouplist.item.id': '方面ID',
  'pages.customerTop.route_grouplist.item.name': '方面名',
  'pages.customerTop.route_grouplist.item.status': '系統設定状態',
  'pages.customerTop.route_grouplist.item.status.completed': '設定済',
  'pages.customerTop.route_grouplist.item.status.uncompleted': '未設定あり',
  'pages.customerTop.route_grouplist.item.operation': '操作',
  'pages.customerTop.route_grouplist.button.add': '新規登録',
  'pages.customerTop.route_grouplist.button.update': '編集',
  'pages.customerTop.route_grouplist.button.routeset': '系統設定',
  'pages.customerTop.route_grouplist.button.jsonupdate': 'JSON再作成',
  'pages.customerTop.route_grouplist.jsonupdate.check': 'JSON再作成しますか？',
  'pages.customerTop.route_grouplist.button.delete': '削除',
  'pages.customerTop.route_grouplist.delete.check': '削除しますか？',
  'pages.customerTop.route_grouplist.delete.exec': '方面ID:{route_groupid}を削除しました',
  'pages.customerTop.route_grouplist.delete.failed': '削除に失敗しました',

  /** 方面名登録／編集 */
  'pages.customerTop.route_group.item.route_groupid': '方面ID',
  'pages.customerTop.route_group.item.route_groupname': '方面名',
  'pages.customerTop.route_group.item.lang': '言語',
  'pages.customerTop.route_group.item.route_groupname.order': '並び順',
  'pages.customerTop.route_group.item.route_groupname.lang': '多言語方面名',
  'pages.customerTop.route_group.item.lang.ja': 'ja',
  'pages.customerTop.route_group.item.lang.jahrkt': 'ja-Hrkt',
  'pages.customerTop.route_group.item.lang.en': 'en',
  'pages.customerTop.route_group.item.lang.ko': 'ko',
  'pages.customerTop.route_group.item.lang.zhhs': 'zh_hans',
  'pages.customerTop.route_group.item.lang.zhht': 'zh_hant',
  'pages.customerTop.route_group.item.route_groupname.hrkt': '方面名（ひらがな）',
  'pages.customerTop.route_group.item.route_groupname.lang1': '方面名（多言語１）',
  'pages.customerTop.route_group.item.route_groupname.lang2': '方面名（多言語２）',
  'pages.customerTop.route_group.item.route_groupname.lang3': '方面名（多言語３）',
  'pages.customerTop.route_group.item.route_groupname.lang4': '方面名（多言語４）',
  'pages.customerTop.route_group.item.route_groupname.lang5': '方面名（多言語５）',
  'pages.customerTop.route_group.item.route_groupname.lang6': '方面名（多言語６）',
  'pages.customerTop.route_group.item.route_groupname.lang7': '方面名（多言語７）',
  'pages.customerTop.route_group.item.route_groupname.lang8': '方面名（多言語８）',
  'pages.customerTop.route_group.item.route_groupname.lang9': '方面名（多言語９）',
  'pages.customerTop.route_group.item.route_groupname.lang10': '方面名（多言語１０）',
  'pages.customerTop.route_group.button.save': '保存',
  'pages.customerTop.route_group.button.back': '戻る',
  'pages.customerTop.route_group.route_groupname.required': '方面名を入力してください',
  'pages.customerTop.route_group.route_groupname_hrkt.required': '方面名をひらがなで入力してください',
  'pages.customerTop.route_group.displayorder.required': '並び順を数字で入力してください',
  'pages.customerTop.route_group.lang.required': '言語を選択してください',
  'pages.customerTop.route_group.route_groupinfo.create': '方面名情報を作成しました',
  'pages.customerTop.route_group.route_groupinfo.update': '方面名情報を更新しました',

  /** 方面-系統・一覧 */
  'pages.customerTop.route_group_routelist.item.routename': '方面名',
  'pages.customerTop.route_group_routelist.item.routesetting': '方面（系統設定）',
  'pages.customerTop.route_group_routelist.item.agencyname': '事業者名',
  'pages.customerTop.route_group_routelist.item.calendarstatus': 'カレンダー状態',
  'pages.customerTop.route_group_routelist.item.revisiondata': 'ダイヤ改正日',
  'pages.customerTop.route_group_routelist.item.calendarstart': 'カレンダー開始日',
  'pages.customerTop.route_group_routelist.item.calendarend': 'カレンダー終了日',
  'pages.customerTop.route_group_routelist.item.totalroute': '対象系統数',
  'pages.customerTop.route_group_routelist.item.registrationstatus': '登録状況',
  'pages.customerTop.route_group_routelist.item.status.registerted': 'チェック',
  'pages.customerTop.route_group_routelist.item.status.unregistered': '未チェック',
  'pages.customerTop.route_group_routelist.item.operation': '操作',
  'pages.customerTop.route_group_routelist.button.update': '編集',
  'pages.customerTop.route_group_routelist.button.confirm': '確認',
  'pages.customerTop.route_group_routelist.button.save': '保存',
  'pages.customerTop.route_group_routelist.button.back': '戻る',
  'pages.customerTop.route_group_routelist.route_groupinfo.create': '方面(系統設定)情報を作成しました',
  'pages.customerTop.route_group_routelist.route_groupinfo.update': '方面(系統設定)情報を更新しました',

  /** 方面-系統・登録／編集 */
  'pages.customerTop.route_group_route.item.routesetting': '系統選択',
  'pages.customerTop.route_group_route.button.importcsv': 'CSV',
  'pages.customerTop.route_group_route.button.clear': 'クリア',
  'pages.customerTop.route_group_route.item.agencyname': 'バス事業者名',
  'pages.customerTop.route_group_route.item.revisiondata': 'ダイヤ改正日',
  'pages.customerTop.route_group_route.item.calendarstart': 'カレンダー開始日',
  'pages.customerTop.route_group_route.item.routelist': '【系統一覧】',
  'pages.customerTop.route_group_route.item.targetroute': '【対象系統】',
  'pages.customerTop.route_group_route.item.routeid': '系統ID',
  'pages.customerTop.route_group_route.item.routeshortname': '系統名１',
  'pages.customerTop.route_group_route.item.routelongname': '系統名２',
  'pages.customerTop.route_group_route.item.search': '検索',
  'pages.customerTop.route_group_route.button.save': '登録',
  'pages.customerTop.route_group_route.button.back': 'キャンセル',
  'pages.customerTop.route_group_route.targetroute.required': '対象の系統を選択してください',
  'pages.customerTop.route_group_route.route_groupinfo.create': '事業者ごとの方面(系統設定)情報を作成しました',
  'pages.customerTop.route_group_route.route_groupinfo.update': '事業者ごとの方面(系統設定)を更新しました',

  /** 標柱グループ一覧 */
  'pages.customerTop.stop_grouplist.item.id': '標柱グループID',
  'pages.customerTop.stop_grouplist.item.name': '標柱グループ名',
  'pages.customerTop.stop_grouplist.item.status': '標柱設定状態',
  'pages.customerTop.stop_grouplist.item.status.completed': '設定済',
  'pages.customerTop.stop_grouplist.item.status.uncompleted': '未設定あり',
  'pages.customerTop.stop_grouplist.item.routeinfo': '方面情報',
  'pages.customerTop.stop_grouplist.item.routeflag.on': '○',
  'pages.customerTop.stop_grouplist.item.routeflag.off': '×',
  'pages.customerTop.stop_grouplist.item.operation': '操作',
  'pages.customerTop.stop_grouplist.button.add': '新規登録',
  'pages.customerTop.stop_grouplist.button.update': '編集',
  'pages.customerTop.stop_grouplist.button.stopset': '標柱設定',
  'pages.customerTop.stop_grouplist.button.routeconfirm': '方面確認',
  'pages.customerTop.stop_grouplist.button.jsonupdate': 'JSON再作成',
  'pages.customerTop.stop_grouplist.jsonupdate.check': 'JSON再作成しますか？',
  'pages.customerTop.stop_grouplist.button.delete': '削除',
  'pages.customerTop.stop_grouplist.delete.check': '削除しますか？',
  'pages.customerTop.stop_grouplist.delete.exec': '標柱グループID:{stop_groupid}を削除しました',
  'pages.customerTop.stop_grouplist.delete.failed': '削除に失敗しました',

  /** 標柱グループ名登録／編集 */
  'pages.customerTop.stop_group.item.routeflag': '方面フラグ',
  'pages.customerTop.stop_group.item.routeflag.on': 'あり',
  'pages.customerTop.stop_group.item.routeflag.off': 'なし',
  'pages.customerTop.stop_group.item.stop_groupid': '標柱グループID',
  'pages.customerTop.stop_group.item.stop_groupname': '標柱グループ名',
  'pages.customerTop.stop_group.item.stop_groupname.order': '並び順',
  'pages.customerTop.stop_group.item.stop_groupname.lang': '多言語標柱グループ名',
  'pages.customerTop.stop_group.item.lang.ja': 'ja',
  'pages.customerTop.stop_group.item.lang.jahrkt': 'ja-Hrkt',
  'pages.customerTop.stop_group.item.lang.en': 'en',
  'pages.customerTop.stop_group.item.lang.ko': 'ko',
  'pages.customerTop.stop_group.item.lang.zhhs': 'zh_hans',
  'pages.customerTop.stop_group.item.lang.zhht': 'zh_hant',
  'pages.customerTop.stop_group.item.stop_groupname.hrkt': '標柱グループ名（ひらがな）',
  'pages.customerTop.stop_group.item.stop_groupname.lang1': '標柱グループ名（多言語１）',
  'pages.customerTop.stop_group.item.stop_groupname.lang2': '標柱グループ名（多言語２）',
  'pages.customerTop.stop_group.item.stop_groupname.lang3': '標柱グループ名（多言語３）',
  'pages.customerTop.stop_group.item.stop_groupname.lang4': '標柱グループ名（多言語４）',
  'pages.customerTop.stop_group.item.route_groupname.lang5': '標柱グループ名（多言語５）',
  'pages.customerTop.stop_group.item.route_groupname.lang6': '標柱グループ名（多言語６）',
  'pages.customerTop.stop_group.item.route_groupname.lang7': '標柱グループ名（多言語７）',
  'pages.customerTop.stop_group.item.route_groupname.lang8': '標柱グループ名（多言語８）',
  'pages.customerTop.stop_group.item.route_groupname.lang9': '標柱グループ名（多言語９）',
  'pages.customerTop.stop_group.item.route_groupname.lang10': '標柱グループ名（多言語１０）',
  'pages.customerTop.stop_group.button.save': '保存',
  'pages.customerTop.stop_group.button.back': '戻る',
  'pages.customerTop.stop_group.stop_groupname.required': '標柱グループ名を入力してください',
  'pages.customerTop.stop_group.stop_groupname_hrkt.required': '標柱グループ名をひらがなで入力してください',
  'pages.customerTop.stop_group.displayorder.required': '並び順を数字で入力してください',
  'pages.customerTop.stop_group.stop_groupinfo.create': '標柱グループ名情報を作成しました',
  'pages.customerTop.stop_group.stop_groupinfo.update': '標柱グループ名情報を更新しました',

  /** 標柱グループ-標柱・一覧 */
  'pages.customerTop.stop_group_stoplist.item.stop_groupname': '標柱グループ名',
  'pages.customerTop.stop_group_stoplist.item.stopsetting': '標柱グループ（標柱設定）',
  'pages.customerTop.stop_group_stoplist.item.agencyname': '事業者名',
  'pages.customerTop.stop_group_stoplist.item.calendarstatus': 'カレンダー状態',
  'pages.customerTop.stop_group_stoplist.item.revisiondata': 'ダイヤ改正日',
  'pages.customerTop.stop_group_stoplist.item.calendarstart': 'カレンダー開始日',
  'pages.customerTop.stop_group_stoplist.item.calendarend': 'カレンダー終了日',
  'pages.customerTop.stop_group_stoplist.item.totalstop': '対象標柱数',
  'pages.customerTop.stop_group_stoplist.item.registrationstatus': '登録状況',
  'pages.customerTop.stop_group_stoplist.item.status.registerted': 'チェック',
  'pages.customerTop.stop_group_stoplist.item.status.unregistered': '未チェック',
  'pages.customerTop.stop_group_stoplist.item.operation': '操作',
  'pages.customerTop.stop_group_stoplist.button.update': '編集',
  'pages.customerTop.stop_group_stoplist.button.confirm': '確認',
  'pages.customerTop.stop_group_stoplist.button.save': '保存',
  'pages.customerTop.stop_group_stoplist.button.back': '戻る',
  'pages.customerTop.stop_group_stoplist.stop_groupinfo.create': '標柱グループ(標柱設定)情報を作成しました',
  'pages.customerTop.stop_group_stoplist.stop_groupinfo.update': '標柱グループ(標柱設定)情報を更新しました',

  /** 標柱グループ-標柱・登録／編集 */
  'pages.customerTop.stop_group_stop.item.stopsetting': '標柱選択',
  'pages.customerTop.stop_group_stop.button.importcsv': 'CSV',
  'pages.customerTop.stop_group_stop.button.clear': 'クリア',
  'pages.customerTop.stop_group_stop.item.agencyname': 'バス事業者名',
  'pages.customerTop.stop_group_stop.item.revisiondata': 'ダイヤ改正日',
  'pages.customerTop.stop_group_stop.item.calendarstart': 'カレンダー開始日',
  'pages.customerTop.stop_group_stop.item.stoplist': '【標柱一覧】',
  'pages.customerTop.stop_group_stop.item.targetstop': '【対象標柱】',
  'pages.customerTop.stop_group_stop.item.stopid': '標柱ID',
  'pages.customerTop.stop_group_stop.item.stopname': '標柱名',
  'pages.customerTop.stop_group_stop.item.search': '検索',
  'pages.customerTop.stop_group_stop.button.save': '登録',
  'pages.customerTop.stop_group_stop.button.back': 'キャンセル',
  'pages.customerTop.stop_group_stop.targetstop.required': '対象の標柱を選択してください',
  'pages.customerTop.stop_group_stop.stop_groupinfo.create': '事業者ごとの標柱グループ(標柱設定)情報を作成しました',
  'pages.customerTop.stop_group_stop.stop_groupinfo.update': '事業者ごとの標柱グループ(標柱設定)を更新しました',

  /** 標柱グループ-標柱・方面確認 */
  'pages.customerTop.stop_group_confirm.item.confirm': '方面確認',
  'pages.customerTop.stop_group_confirm.item.stopgroup_name': '標柱グループ名',
  'pages.customerTop.stop_group_confirm.item.agencyname': '事業者名',
  'pages.customerTop.stop_group_confirm.item.revisiondata': 'ダイヤ改正日',
  'pages.customerTop.stop_group_confirm.item.calendarstart': 'カレンダー開始日',
  'pages.customerTop.stop_group_confirm.item.calendarend': 'カレンダー終了日',
  'pages.customerTop.stop_group_confirm.item.stopname': '標柱名',
  'pages.customerTop.stop_group_confirm.item.totalstop': '対象標柱数',
  'pages.customerTop.stop_group_confirm.item.route_groupname': '方面名',
  'pages.customerTop.stop_group_confirm.button.back': '戻る',

  // 'pages.welcome.link': 'ようこそ',
  // 'pages.welcome.alertMessage':
  //   'より高速で強力な頑丈なコンポーネントがリリースされました。',
  'pages.404.subTitle':
    'アクセスしたページは存在しません。',
  'pages.404.buttonText': 'ホーム',
  // 'pages.admin.subPage.title': 'このページは管理者のみが表示できます',
  // 'pages.admin.subPage.alertMessage':
  //   'Umi uiがリリースされました。npm run uiを使用して体験してください。',

  // 'pages.searchTable.createForm.newRule': '新しいルール',
  // 'pages.searchTable.updateForm.ruleConfig': 'ルール構成',
  // 'pages.searchTable.updateForm.basicConfig': '基本情報',
  // 'pages.searchTable.updateForm.ruleName.nameLabel': 'ルール名',
  // 'pages.searchTable.updateForm.ruleName.nameRules':
  //   'ルール名を入力してください！',
  // 'pages.searchTable.updateForm.ruleDesc.descLabel': 'ルールの説明',
  // 'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
  //   '5文字以上入力してください',
  // 'pages.searchTable.updateForm.ruleDesc.descRules':
  //   '5文字以上のルールの説明を入力してください！',
  // 'pages.searchTable.updateForm.ruleProps.title': 'プロパティの構成',
  // 'pages.searchTable.updateForm.object': '監視対象',
  // 'pages.searchTable.updateForm.ruleProps.templateLabel': 'ルールテンプレート',
  // 'pages.searchTable.updateForm.ruleProps.typeLabel': 'ルールタイプ',
  // 'pages.searchTable.updateForm.schedulingPeriod.title':
  //   'スケジュール期間の設定',
  // 'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  // 'pages.searchTable.updateForm.schedulingPeriod.timeRules':
  //   '開始時間を選択してください！',
  // 'pages.searchTable.titleDesc': '説明',
  // 'pages.searchTable.ruleName': 'ルール名が必要です',
  // 'pages.searchTable.titleCallNo': 'サービスコール数',
  // 'pages.searchTable.titleStatus': 'ステータス',
  // 'pages.searchTable.nameStatus.default': 'デフォルト',
  // 'pages.searchTable.nameStatus.running': '起動中',
  // 'pages.searchTable.nameStatus.online': 'オンライン',
  // 'pages.searchTable.nameStatus.abnormal': '異常',
  // 'pages.searchTable.titleUpdatedAt': '最終スケジュール',
  // 'pages.searchTable.exception': '例外の理由を入力してください！',
  // 'pages.searchTable.titleOption': 'オプション',
  // 'pages.searchTable.config': '構成',
  // 'pages.searchTable.subscribeAlert': 'アラートを購読する',
  // 'pages.searchTable.title': 'お問い合わせフォーム',
  // 'pages.searchTable.new': '新しい',
  // 'pages.searchTable.chosen': '選んだ項目',
  // 'pages.searchTable.item': '項目',
  // 'pages.searchTable.totalServiceCalls': 'サービスコールの総数',
  // 'pages.searchTable.tenThousand': '万',
  // 'pages.searchTable.batchDeletion': 'バッチ削除',
  // 'pages.searchTable.batchApproval': 'バッチ承認',
};
